// Mock data para Gafas La Tri Landing Page

export const products = [
  {
    id: 1,
    name: "Modelo Amarillo",
    color: "Amarillo",
    colorHex: "#fbbf24",
    description: "Energía y alegría para los que celebran cada gol como el primero.",
    price: 27.99,
    oldPrice: 30,
    image: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/ijxagrio_gafas-de-la-tri-amarillo-frente.png",
    imageWithBox: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/tz8ly7yd_gafas-de-la-tri-amarillo-caja.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/ijxagrio_gafas-de-la-tri-amarillo-frente.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/ibbx6r2p_gafas-de-la-tri-amarillo-lateral.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/wv8f4mdz_gafas-de-la-tri-amarillo-persona.png"
    ],
    inStock: true
  },
  {
    id: 2,
    name: "Modelo Azul",
    color: "Azul",
    colorHex: "#1e3a8a",
    description: "Versátil y sobrio, ideal para oficina, partidos y viajes.",
    price: 27.99,
    oldPrice: 30,
    image: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/wbrynwy0_gafas-de-la-tri-azul-frente.png",
    imageWithBox: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/40jzedu4_gafas-de-la-tri-azul-caja.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/wbrynwy0_gafas-de-la-tri-azul-frente.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/z55zkk6j_gafas-de-la-tri-azul-lateral.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/czf2qmrw_gafas-de-la-tri-azul-persona.png"
    ],
    inStock: true
  },
  {
    id: 3,
    name: "Modelo Rojo",
    color: "Rojo",
    colorHex: "#dc2626",
    description: "Carácter fuerte para los que viven cada jugada al límite.",
    price: 27.99,
    oldPrice: 30,
    image: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/zh17wf8u_gafas-de-la-tri-rojo-frente.png",
    imageWithBox: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/4uqwv42j_gafas-de-la-tri-rojo-caja.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/zh17wf8u_gafas-de-la-tri-rojo-frente.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/76sotu9s_gafas-de-la-tri-rojo-lateral.png",
      "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/4i5mfcbc_gafas-de-la-tri-rojo-persona.png"
    ],
    inStock: true
  }
];

export const lifestyleImages = {
  heroLifestyle: "/lifestyle/padre_hijo_celebrando.png",
  stadium: "/lifestyle/padre_estadio_solo.png",
  family: "/lifestyle/familia_partido_casa.png",
  outdoor: "/lifestyle/padre_paseo_aire_libre.png"
};

export const pricingOptions = [
  {
    id: 1,
    quantity: 1,
    price: 27.99,
    oldPrice: 30,
    label: "1 Par",
    description: "Para ti",
    savings: 0,
    popular: false
  },
  {
    id: 2,
    quantity: 2,
    price: 52.99,
    oldPrice: 55,
    pricePerUnit: 26.50,
    label: "2 Pares",
    description: "Combo Familiar",
    savings: 2.99,
    popular: true
  },
  {
    id: 3,
    quantity: 3,
    price: 72.99,
    oldPrice: 75,
    pricePerUnit: 24.33,
    label: "3 Pares",
    description: "Máximo Ahorro",
    savings: 10.98,
    popular: false
  }
];

export const features = [
  {
    id: 1,
    icon: "shield-check",
    title: "Protección UV400",
    description: "Protección completa para tus ojos en cada aventura."
  },
  {
    id: 2,
    icon: "feather",
    title: "Ligeras",
    description: "Materiales resistentes y ultra ligeros para máximo confort."
  },
  {
    id: 3,
    icon: "sparkles",
    title: "Antirreflejo",
    description: "Lentes con tratamiento antirreflejo para visión clara."
  },
  {
    id: 4,
    icon: "smile",
    title: "Ajuste Perfecto",
    description: "Diseñadas para uso prolongado sin presiones."
  }
];

export const reasons = [
  {
    id: 1,
    icon: "calendar",
    title: "Uso diario",
    description: "Diseño que combina con tu ropa de todos los días, no solo con la camiseta."
  },
  {
    id: 2,
    icon: "heart",
    title: "Identidad futbolera",
    description: "Colores de La Tri y detalles que muestran tu pasión sin exagerar."
  },
  {
    id: 3,
    icon: "smile",
    title: "Comodidad real",
    description: "Ligeras, cómodas y pensadas para acompañarte todo el día."
  }
];

export const included = [
  {
    id: 1,
    icon: "glasses",
    title: "Gafas Oficiales",
    description: "Gafas La Tri con todos los detalles"
  },
  {
    id: 2,
    icon: "box",
    title: "Caja Rígida",
    description: "Protección premium para tus gafas"
  },
  {
    id: 3,
    icon: "package",
    title: "Funda Protectora",
    description: "Funda suave para transporte"
  },
  {
    id: 4,
    icon: "sparkles",
    title: "Paño de Limpieza",
    description: "Mantén tus lentes impecables"
  }
];

export const retailers = [
  {
    name: "Supermaxi",
    logo: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/58czyo96_logo-supermaxi.png"
  },
  {
    name: "Megamaxi",
    logo: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/y02mmymd_logo-megamaxi.png"
  },
  {
    name: "AKÍ",
    logo: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/5513y6ix_logo-aki.png"
  },
  {
    name: "Marathon Sports",
    logo: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/m12drpp5_logo-marathon.png"
  },
  {
    name: "Islas Panini",
    logo: "https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/pdciqo3l_logo-panini.png"
  }
];

export const shippingInfo = {
  nationalCost: 2.75,
  freeShippingThreshold: 50,
  coverage: "Todo el Ecuador",
  pickupLocation: "Quito",
  pickupAvailable: true
};

export const contactInfo = {
  whatsapp: "+593962888130",
  whatsappLink: "https://wa.me/593962888130"
};

export const paymentConfig = {
  enablePayphone: true,
  enableWhatsApp: true
};

export const paymentLink = "https://payment-link.com/gafas-la-tri"; // Este será reemplazado por el link real
